<template>
  <material-card>
    <v-toolbar slot="header" color="primary">
      <v-toolbar-title>Survey</v-toolbar-title>
    </v-toolbar>
    <v-card class="mb-6 pb-2">
      <v-card-title>Details</v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        QUESTION:
        <VTextarea filled v-model="survey.question" />
        FOOTER MESSAGE:
        <VTextarea filled v-model="survey.footer_message" />
        THANK YOU MESSAGE:
        <VTextarea filled v-model="survey.thankyou_message" />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="canEdit"
          color="primary"
          @click="updateSurvey(survey.question)"
        >
          Update survey
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mb-6">
      <v-card-title
        >Options:<v-btn
          class="ml-4"
          v-if="canEdit"
          small
          outlined
          color="primary"
          @click="areasDialog = true"
        >
          Add option
        </v-btn></v-card-title
      >
      <v-divider class="mx-4"></v-divider>

      <v-list>
        <v-list-item v-for="area in options" :key="area.id">
          <v-list-item-content>
            <VTextarea
              auto-grow
              filled
              rows="2"
              label="Option text"
              v-model="area.answer"
              :rules="[(v) => !!v || 'Option is required']"
            />
          </v-list-item-content>

          <v-list-item-action style="align-self: flex-start">
            <div>
              <v-btn icon @click="updateOption(area.id, area.answer)">
                <v-icon color="grey">mdi-file-document-edit-outline</v-icon>
              </v-btn>
              <v-btn icon v-if="canEdit" @click="deleteOption(area.id)">
                <v-icon color="grey">mdi-delete</v-icon>
              </v-btn>
            </div>
          </v-list-item-action>
        </v-list-item>
        <div v-if="areaList.length === 0" class="text-center">
          This survey has no options
        </div>
      </v-list>
    </v-card>
    <v-card class="mb-6">
      <v-card-title
        >Banners <v-spacer></v-spacer
        ><UploadForm
          v-if="canEdit"
          :uploadFieldLabel="'Select banner'"
          @file-submitted="uploadBanner"
      /></v-card-title>
      <v-divider class="mx-4"></v-divider>
      <div class="pa-4">
        <v-card class="mb-4" v-for="banner in banners" :key="banner.id">
          <div class="d-flex justify-space-between">
            <div>
              <v-card-text class="mr-auto" style="widht: 100%">
                <VTextField
                  filled
                  label="Url"
                  placeholder="Insert url"
                  v-model="banner.url"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn
                  @click="updateBanner(banner)"
                  class="ml-2 mt-3"
                  height="40px"
                  color="primary"
                  right
                >
                  Update <v-icon>mdi-square-edit-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="canEdit"
                  @click="deleteBanner(banner.id)"
                  class="ml-2 mt-3"
                  height="40px"
                  color="primary"
                  otlined
                  right
                >
                  Delete <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </div>
            <v-avatar class="ma-3" size="125" tile>
              <v-img :src="banner.banner" contain></v-img>
            </v-avatar>
          </div>
        </v-card>
      </div>
    </v-card>
    <v-card>
      <v-card-title
        >Coupon<CouponUploadForm
          v-if="canEdit"
          :uploadFieldLabel="'Select coupon'"
          @file-submitted="uploadLogo"
          :color="'primary'"
      /></v-card-title>
      <v-card-text>
        <!-- <a
          v-if="survey.coupon"
          download="coupon"
          target="_blank"
          :href="survey.coupon || '#'"
          >Download coupon</a
        > -->
        <a  v-if="survey.coupon_uploaded" target="_blank" :href="couponUrl">Download coupon</a>
        <span v-else>No coupon uploaded</span>
      </v-card-text>
      <v-card-text>
        Coupon label:
        <VTextarea filled v-model="survey.coupon_label" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="canEdit"
          color="primary"
          @click="updateSurvey(survey.question)"
        >
          Update survey
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="areasDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>Add option</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="areasAssociation" v-model="areasAssociation.valid">
            <VTextarea filled auto-grow rows="2" v-model="optionText" />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="secondary darken-1"
            outlined
            @click="areasDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="optionText.length === 0"
            @click="
              addOption(optionText);
              areasDialog = false;
            "
            >Add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </material-card>
</template>
<script>
import apiService from '@/services'
import { mapState } from 'vuex'
import UploadForm from './BannerUploader'
import CouponUploadForm from '@/components/npos/ComponentUpload'

export default {
  props: {
    canEdit: {
      type: Boolean,
      default: false
    },
    entityId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  components: {
    UploadForm,
    CouponUploadForm
  },
  computed: {
    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas']),
    couponUrl () {
      return `${process.env.VUE_APP_BASE_URL}/surveys/${this.survey.id}/download/coupon`
    }
  },
  mounted () {
    this.getSurvey(this.entityId)
  },
  data () {
    return {
      optionText: '',
      areaList: [],
      options: [],
      banners: [],
      survey: {},
      areasDialog: false,
      areasAssociationRequest: [],
      areasAssociation: {
        valid: false
      }
    }
  },
  methods: {
    getSurvey (campaignId) {
      apiService
        .getSurvey(campaignId)
        .then((data) => {
          this.areaList = data
          this.survey = data.data
          this.surveyId = data.data.id
          this.options = data.data.answers
          this.banners = data.data.banners
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },

    addOption (option) {
      const newOptions = []
      newOptions.push({
        survey: this.surveyId,
        answer: option
      })
      apiService
        .addOption(newOptions)
        .then((response) => {
          this.getSurvey(this.entityId)
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },

    deleteOption (optionId) {
      console.log('Deleting', optionId)
      apiService
        .deleteOption(optionId)
        .then((response) => {
          this.getSurvey(this.entityId)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Option deleted'
          })
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },
    uploadLogo (formData) {
      const npoId = this.surveyId
      apiService
        .uploadCoupon(npoId, formData)
        .then((response) => {
          this.updateSurvey()
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },
    downloadCoupon () {
      console.log('ADD Coupon', this.surveyId)
      this.survey.coupon = formData
      this.updateSurvey()

    },
    uploadCoupon (formData) {
      console.log('ADD Coupon', this.surveyId)
      this.survey.coupon = formData
      this.updateSurvey()
    },
    updateOption (id, answer) {
      const newOptions = []
      newOptions.push({
        id: id,
        answer: answer
      })
      apiService
        .updateOption(newOptions)
        .then((response) => {
          this.getSurvey(this.entityId)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Option updated'
          })
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },

    uploadBanner (formData) {
      console.log('ADD BANNER', this.surveyId)
      const data = [
        {
          survey: this.surveyId,
          banner: formData
        }
      ]
      apiService.addBanner(data).then((response) => {
        console.log('RESPONSE', response)
        this.getSurvey(this.entityId)
      })
    },

    updateBanner (banner) {
      const data = []
      data.push(banner)
      apiService
        .updateBanner(data)
        .then((response) => {
          this.getSurvey(this.entityId)
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },

    deleteBanner (optionId) {
      console.log('Deleting', optionId)
      apiService
        .deleteBanner(optionId)
        .then((response) => {
          this.getSurvey(this.entityId)
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },

    updateSurvey () {
      apiService
        .updateSurvey(this.survey)
        .then((response) => {
          this.getSurvey(this.entityId)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Survey updated'
          })
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    }
  }
}
</script>
